import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=f5bf9a30&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=f5bf9a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bf9a30",
  null
  
)

export default component.exports